// extracted by mini-css-extract-plugin
export default {"text":"OneLineTextDiv_text__etHEV","subtitle":"OneLineTextDiv_subtitle__51+do","hightLightText":"OneLineTextDiv_hightLightText__MYrEV"};